/** Most patients one appointment holds. */
export const MAX_APPOINTMENT_PARTICIPANTS = 5;
//# sourceMappingURL=appointment-participants.const.js.map